import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { HatcheriesDto } from './hatcheries.dto';


export class AllHatcheriesResponseModel extends GlobalResponseObject {
    data?: HatcheriesDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: HatcheriesDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

